import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useI18n } from "../lib/i18n.jsx";
import { PageHeader } from "../components/Bits";
import { useAuth } from "../context/AuthContext";
import { NoAccess } from "../components/WarehouseBits";
import { Warehouse as WIcon, FolderTree, Wrench, History, ClipboardCheck, ClipboardList } from "lucide-react";

const TABS = [
  { to: "/warehouse", key: "warehouses", icon: WIcon, end: true },
  { to: "/warehouse/registry", key: "asset_registry", icon: ClipboardList },
  { to: "/warehouse/catalog", key: "catalog", icon: FolderTree },
  { to: "/warehouse/assets", key: "assets", icon: Wrench },
  { to: "/warehouse/history", key: "history", icon: History },
  { to: "/warehouse/inventory", key: "inventory", icon: ClipboardCheck, perm: "warehouse.inventory.view" },
];

export default function Warehouse() {
  const { t } = useI18n();
  const { can } = useAuth();
  if (!can("warehouse.view")) return <div data-testid="warehouse-page"><PageHeader title={t("warehouse")} /><NoAccess /></div>;
  return (
    <div data-testid="warehouse-page" className="min-w-0">
      <PageHeader title={t("warehouse")} />
      <div className="flex gap-1 mb-4 overflow-x-auto" data-testid="warehouse-tabs">
        {TABS.filter((x) => !x.perm || can(x.perm)).map(({ to, key, icon: Icon, end }) => (
          <NavLink key={key} to={to} end={end} data-testid={`wh-tab-${key}`}
            className={({ isActive }) => `flex items-center gap-2 px-3 py-2 rounded-md text-sm font-semibold whitespace-nowrap ${isActive ? "bg-[var(--sidebar)] text-white" : "tactical-card"}`}>
            <Icon size={16} /> {t(key)}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
